import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Button,
    Card,
    Divider,
    Icon,
    IconButton,
    List,
    ListItem,
    ListItemText, makeStyles,
    Popover,
    Tooltip
} from "@material-ui/core";
import {Draggable, Droppable} from 'react-beautiful-dnd'
import {set} from "object-path-immutable";
import FormField from "../../../../../../Utils/Form/Fields/FormField";
import _ from 'lodash';
import listRequestWrapper from "../../../../../../Services/API/listRequestWrapper";
import SelectType from "../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../JsonScreen/Utils/lib";

const styles = () => ({
    cardContentWrapper: {
        height: 120,
        overflowY: "auto"
    },
    cardContentRoot: {
        padding: 0,
        overflowY: "auto"
    },
    editIcon: {
        padding: 0
    },
    list: {
        paddingTop: 0
    },
    table: {
        width: '100%',
        marginTop: '5px',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        width: '250px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    formActionsWrapper: {
        margin: '5px 5px 5px 0',
        textAlign: 'right',
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        margin: '0 2px',
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
});
const useStyles = makeStyles(() => ({
    cardContentWrapper: {
        height: 120,
        overflowY: "auto"
    },
    cardContentRoot: {
        padding: 0,
        overflowY: "auto"
    },
    editIcon: {
        padding: 0
    },
    list: {
        paddingTop: 0
    },
    table: {
        width: '100%',
        marginTop: '5px',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        width: '250px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    formActionsWrapper: {
        margin: '5px 5px 5px 0',
        textAlign: 'right',
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        margin: '0 2px',
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
}))
class FilterColumns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            operands: [],
            columnInEdit: {},
            anchorEl: null,
            errorComponent: false,
            operandsByType: [],
            columnSchema: {
                name: {
                    type: "string",
                    name: "name",
                    path: "name",
                    disabled: false
                },
                label: {
                    type: "string",
                    name: "label",
                    path: "label",
                    disabled: false,
                    multiLanguage: true
                },
                type: {
                    type: "autocomplete",
                    name: "type",
                    label: "Type",
                    path: "type",
                    options: [
                        {label: "String", value: "string"},
                        {label: "Number", value: "number"},
                        {label: "Integer", value: "integer"},
                        {label: "Date", value: "date"},
                        {label: 'Date Time', value: 'dateTime'},
                        {label: "Boolean", value: "bool"},
                        {label: "EntityExternal", value: "entityExternal"}
                    ]
                },
                required: {
                    type: "switch",
                    name: "required",
                    path: "required",
                    disabled: false
                },
                operands: {
                    type: 'objSelect',
                    name: 'operands',
                    label: 'Operands',
                    optLabel: 'label',
                    path: 'operands',
                    isArray: true,
                    disabled: false
                },
                entity: {
                    name: 'entity',
                    type: 'autocomplete',
                    source: 'schema',
                    label: 'Entity',
                    path: 'entity',
                }
            }
        }
    }


    componentDidMount = async () => {
        await this.getOperands();
    };

    getOperands = async () => {
        let operands = await listRequestWrapper('operand');
        this.setState({operands})
    };

    openEditColumn = (event, column, index, isCustom) => {
        const {operands} = this.state;
        const currentTarget = event.currentTarget;
        if (column.operands && column.operands.length > 0) {
            column.operands = typeof column.operands[0] === "object" ?
                column.operands :
                getOperandName(column.operands, operands).map(i => ({value: i.id, label: i.name}))
        }

        this.setState(state => ({
            columnInEdit: column,
            anchorEl: currentTarget,
            columnIndex: index,
            operandsByType: operandsByType(state.operands, column.type),
            isCustom
        }))
    };

    closeEditColumn = () => {
        this.setState({columnInEdit: {}, anchorEl: null, columnIndex: null})
    };

    //Form handler
    onChangeProps = (event, path, isCheckBox) => {
        const {columnInEdit} = this.state;
        const newValues = set(columnInEdit, path, isCheckBox === true ? event.target.checked : event.target.value);
        this.setState({columnInEdit: newValues})
    };
    onChangePropsAutocomplete = (value, path) => {
        const {columnInEdit} = this.state;
        const newValues = set(columnInEdit, path, value);
        this.setState({columnInEdit: newValues})
    };
    onChangeAutoCompleteMulti = (value, path) => {
        const {columnInEdit} = this.state;
        const newValues = set(columnInEdit, path, value);
        this.setState({columnInEdit: newValues})
    };

    renderFormEditColumn = () => {
        const {anchorEl, columnInEdit, columnSchema, operandsByType} = this.state;
        const {classes} = this.props;
        return (
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                PaperProps={{
                    style: {maxWidth: 610}
                }}
                onClose={this.closeEditColumn}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>Name</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.name}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.name.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Label</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.label}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.label.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Type</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.type}
                                onChangeAutoComplete={this.onChangePropsAutocomplete}
                                values={columnInEdit || {}}
                                path={columnSchema.type.path}
                                options={columnSchema.type.options}
                            />
                        </td>
                    </tr>

                    {columnInEdit.type === 'entityExternal' && (
                        <tr>
                            <td className={classes.tableCellLabel}>Entity</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={{...columnSchema.entity, disabled: columnInEdit.type !== 'entityExternal'}}
                                    onChangeAutoComplete={this.onChangePropsAutocomplete}
                                    values={columnInEdit || {}}
                                    path={columnSchema.entity.path}
                                />
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td className={classes.tableCellLabel}>Required</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.required}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.required.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>Operands</td>
                        <td className={classes.tableCell}>
                            <SelectType
                                showLabel={true}
                                field={{
                                    ...columnSchema.operands,
                                    values: operandsByType.map(v => ({value: v.id, label: v.name}))
                                }}
                                setValue={this.onChangeAutoCompleteMulti}
                                values={columnInEdit}
                                labelStyles={{}}
                                fieldStyles={{withoutStyles: true, fullWidth: true}}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>

                {this.formAction()}
            </Popover>
        )
    };

    formAction = () => {
        const {classes, setFilterProps, createFilterProps, removeFilterProps} = this.props;
        const {columnInEdit, columnIndex, isCustom} = this.state;
        return (
            <div className={classes.formActionsWrapper}>
                <Button size={"small"} variant="contained" color="primary" onClick={() => {
                    isCustom ? createFilterProps(columnInEdit) : setFilterProps(columnInEdit, columnIndex);
                    this.closeEditColumn();
                }}>Apply</Button>
                {!isCustom && (
                    <Button
                        size={"small"}
                        style={{margin: "0 0 0 10px"}}
                        variant="contained" color="default"
                        onClick={() => {
                            removeFilterProps(columnInEdit, columnIndex);
                            this.closeEditColumn()
                        }}>
                        Remove
                    </Button>
                )}
                <Button size={"small"} variant="contained" color="default" onClick={this.closeEditColumn}
                        style={{margin: "0 0 0 10px"}}>
                    Cancel
                </Button>
            </div>
        )
    };

    render() {
        const {classes, sourceType, filterColumns} = this.props;
        const {errorComponent} = this.state;
        const creatable = (sourceType === 'QUERY') || (sourceType === 'ROUTINE');
        return (
            errorComponent ? (
                <p>Something bad with valueColumns component</p>
            ) : (
                <>
                    <Card className={classes.fieldset}>
                        <legend style={{fontWeight: 'bold'}}>
                            Filter Columns
                        </legend>
                        <Divider/>
                        <Droppable droppableId={'filterColumns'}>
                            {(provided) => (
                                <div className={classes.cardContentWrapper}
                                     {...provided.droppableProps}
                                     ref={provided.innerRef}>

                                    <List dense={true}
                                          className={classes.list}
                                    >
                                        <RenderColumns
                                            openEditColumn={this.openEditColumn}
                                            filterColumns={filterColumns}
                                        />
                                    </List>
                                    {provided.placeholder}

                                    {/* open custom filter column */}
                                    {creatable && (
                                        <div style={{textAlign: "center"}}>
                                            <Tooltip title={'Add custom filter column'}>
                                                <IconButton
                                                    onClick={(event) => this.openEditColumn(event, {}, 0, true)}
                                                    classes={{root: classes.editIcon}}>
                                                    <Icon fontSize={"small"}>
                                                        add
                                                    </Icon>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    )}
                                </div>
                            )}
                        </Droppable>
                        {this.renderFormEditColumn()}
                    </Card>
                </>
            )
        )
    }
}
const RenderColumns = ({filterColumns = [], openEditColumn}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);

    return (
        filterColumns.map((column, index) => {
            const multiLanguageLabel = multiLanguageValue(column.label, userLanguage)
            return (
                <React.Fragment key={`pivot_${column.name}_${index}`}>
                    <Draggable
                        draggableId={`${column.name}_pivot`}
                        index={index}>
                        {(provided, snapshot) => (
                            <>
                                <ListItem
                                    classes={{dense: classes.listItemDense}}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    selected={snapshot.isDragging}
                                    onDoubleClick={(event) => openEditColumn(event, column, index)}
                                >
                                    <ListItemText
                                        primary={multiLanguageLabel}
                                    />
                                    <IconButton
                                        size={"small"}
                                        onClick={(event) => openEditColumn(event, column, index)}
                                        classes={{root: classes.editIcon}}>
                                        <Icon fontSize={"small"}>
                                            more_vert
                                        </Icon>
                                    </IconButton>
                                </ListItem>
                                <Divider/>
                            </>
                        )}
                    </Draggable>
                </React.Fragment>
            )
        })
    )
}
export default withStyles(styles)(FilterColumns)

function operandsByType(operands, type) {
    let operandsByType = [];
    if (type) {
        operands.forEach(op => {
            if (!op.type) {
                operandsByType.push(op)
            } else {
                op.type.forEach(t => {
                    if (t === type.toUpperCase()) {
                        operandsByType.push(op)
                    }
                })
            }
        });
        return operandsByType
    } else {
        return operands;
    }


}

function getOperandName(value, operands) {
    let newValues = [];
    value.forEach(i => {
        if (typeof i === 'string') {
            newValues.push(_.find(operands, (o) => o.id === i))
        } else {
            newValues.push(i)
        }
    });

    return newValues;
}
